module.exports = __webpack_public_path__ + "static/media/goods5_1.65f9f4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods5_1.png
// module id = 1233
// module chunks = 0